<template>
  <v-card
      class="rounded-lg"
      :height="420"
      :width="280"
  >
    <v-card-text class="pa-6" style="position: relative;">
      <div
          style="position: absolute; top: 5px; left: 5px; height: 23px; width: 23px; border-radius: 5px; border: 1px solid lightgray;"
          class="text-center"
      >{{ index + 1 }}
      </div>
      <div class="font-weight-bold text-center black--text" style="height: 50px;">
        {{ card.title }}
      </div>
      <div class="text-center black--text" style="height: 130px;">
        {{ card.description }}
      </div>
      <v-divider></v-divider>
      <div class="mt-4 black--text">What tool would you suggest for this challenge?</div>
      <div class="rounded-lg mt-4"
           style="width: 100%; height: 112px; border: 1px solid lightgray; cursor: pointer;"
           v-if="!card.tool"
           v-ripple
           @click="openToolSelector(card)"
      >
        <v-row no-gutters justify="center" align="center" class="fill-height">
          <v-col cols="auto">
            <div>Click to select a tool</div>
          </v-col>
        </v-row>
      </div>
      <div class="rounded-lg mt-4"
           style="width: 100%; height: 112px; border: 1px solid lightgray; cursor: pointer;"
           v-ripple
           v-else
           @click="openToolSelector(card)"
      >
        <v-img
            contain
            :height="112"
            :src="require(`@/assets/images/brand_logos/${card.tool.file}`)"
        ></v-img>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SelectedFittCard",
  props: {
    card: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  methods: {
    openToolSelector(card) {
      this.$emit('openTools', card);
    }
  },
}
</script>

<style scoped>

</style>